<template>
  <CardSection :error="majorError">
    <template #header>
      Mask new zip file
    </template>
    <template #body>
      <form @submit.prevent="onSubmit">
        <FileInput
          v-model="zipFile"
          label="Zip file to mask"
          name="mask_csv_zip_file_upload"
          accept=".zip"
          rules="required"
        />
        <ActionToolbar
          primary-button-text="Upload & Extract Columns"
          secondary-button-text="Cancel"
          primary-type="submit"
          :component-state="currentState"
          :error-message="formError"
          @secondary-click="cancel"
        />
      </form>
    </template>
  </CardSection>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import CardSection from "@/src/components/shared/CardSection.vue";
import ActionToolbar from "@/src/components/shared/ActionToolbar.vue";
import FileInput from "@/src/components/shared/FormComponents/FileInput.vue";
import { useSavableState } from "@/src/composables/useSavableState";
import { MaskCSVZip } from "@/src/models/unos/mask-csv-zip";

const router = useRouter();
const { majorError, formError, currentState, performAsyncProcessing } = useSavableState();

const zipFile = ref<File | null>(null);

const onSubmit = () => {
  if (!zipFile.value) return;

  performAsyncProcessing(async () => {
    const record = await MaskCSVZip.create();
    await MaskCSVZip.uploadZip(record.id, zipFile.value!);
    await MaskCSVZip.extractColumnInfo(record.id);
    router.push({ name: 'admin_unos_mask_csv_show', params: { id: record.id } });
  });
};

const cancel = () => {
  router.push({ name: 'admin_unos_mask_csv' });
};
</script>
